module.exports = __webpack_public_path__ + "static/media/Davos Seaworth 1.deff2e44.jpg";